import { useEffect, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

interface Props {
  existingValue: any;
  inputSize: "sm" | "lg" | "xl" | "md";
  disabled: boolean;
  autoFocus?: boolean;
  onChange: (val: string) => void;
  setError?: (error: string | null) => void;
}

const Phone = ({
  existingValue,
  onChange,
  inputSize,
  disabled,
  autoFocus = false,
  setError,
}: Props) => {
  const [value, setValue] = useState(existingValue);

  const handleChange = (phone: any) => {
    setError && setError(null);
    setValue(phone);
    if (typeof onChange === "function") onChange(phone);
  };

  useEffect(() => {
    setValue(existingValue);
  }, [existingValue]);

  return (
    <PhoneInput
      className={`crm-record-phoneinput ${inputSize ? inputSize : ""}`}
      defaultCountry="US"
      international
      placeholder="Phone Number"
      value={value}
      onChange={handleChange}
      focusInputOnCountrySelection={autoFocus}
      error={
        value
          ? isValidPhoneNumber(value)
            ? undefined
            : "Invalid phone number"
          : "Phone number required"
      }
      disabled={disabled}
      onBlur={() => {
        if (value === null || value === "" || value === undefined) {
          setError && setError("Invalid Phone");
          return;
        }

        setError && setError(null);
      }}
    />
  );
};

export default Phone;
